module.exports = __webpack_public_path__ + "static/media/SetPoints.2bee7dec.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pdf/SetPoints.pdf
// module id = 380
// module chunks = 0